// src/common/api/notice.js
import api from '@common/api';

/**
 * 获取未读通知列表
 * GET /api/convoy/notice/unread
 */
export const getUnreadNotices = () => api.get('/convoy/notice/unread');

/**
 * 单条已读
 * POST /api/convoy/notice/read
 * @param {number|string} id - 通知 ID
 */
export const markNoticeRead = (id) =>
  api({
    url: '/convoy/notice/read',
    method: 'POST',
    data: { id },
  });

/**
 * 全部已读
 * POST /api/convoy/notice/all_read
 */
export const markAllNoticesRead = () =>
  api({
    url: '/convoy/notice/all_read',
    method: 'POST',
  });
